import EventsSerializer from './base';

export default class Template extends EventsSerializer {}
